function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#e60000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.304 7.527l-6.09-6.092c-.25-.334-.19-.805.136-1.066.12-.142.294-.23.48-.24.187-.01.37.056.505.184l6.094 6.091-1.125 1.123z",
  transform: "translate(1.667 3.333)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.544 5.54l-6.38 6.38c-.249.334-.188.805.138 1.065.12.143.294.23.48.241.187.01.37-.056.505-.184l6.38-6.38-1.123-1.123z",
  transform: "translate(1.667 3.333)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.752 5.952H.744C.546 5.96.36 6.05.23 6.2c-.13.15-.19.349-.167.546-.017.403.281.75.681.794h14.008V5.952z",
  transform: "translate(1.667 3.333)"
})));

var SvgArrowRight = function SvgArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-right.42263b6c.svg";
export { ForwardRef as ReactComponent };